<div class="flex h-full min-h-20 w-full flex-col gap-4">
  <div class="z-999 mx-auto flex w-full max-w-screen-lg flex-col rounded-2xl">
    <div
      class="relative mx-0 mt-0 flex h-full !w-full items-center justify-between gap-2 rounded-2xl border border-gray-200 bg-white p-2"
      #componentHeader
    >
      <span class="absolute inset-x-0 text-center text-xl font-medium">
        Offerta tecnica
      </span>
      <div class="flex items-center gap-2">
        <button
          mat-icon-button
          class="h-full self-center"
          (click)="historyService.undo()"
          [disabled]="historyService.undoDisabled()"
          pTooltip="Annulla modifica"
          tooltipPosition="bottom"
        >
          <mat-icon svgIcon="heroicons_solid:arrow-uturn-left"></mat-icon>
        </button>
        <button
          mat-icon-button
          class="h-full self-center"
          (click)="historyService.redo()"
          [disabled]="historyService.redoDisabled()"
          pTooltip="Ripeti modifica"
          tooltipPosition="bottom"
        >
          <mat-icon svgIcon="heroicons_solid:arrow-uturn-right"></mat-icon>
        </button>
      </div>
      <div class="col-span-3 flex h-full flex-row self-center">
        <button mat-icon-button class="self-end" (click)="openInstructions()">
          <mat-icon svgIcon="heroicons_outline:question-mark-circle"></mat-icon>
        </button>
        <button
          mat-icon-button
          class="h-full self-center"
          (click)="this.builderService.addSection()"
          pTooltip="Aggiungi sezione"
          tooltipPosition="bottom"
        >
          <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
        </button>
        <button
          mat-icon-button
          class="h-full self-center"
          (click)="this.builderService.resetModuleStructure()"
          pTooltip="Pulisci tutto"
          tooltipPosition="bottom"
        >
          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          class="p-button-outlined h-full self-center hover:cursor-pointer"
          (click)="builderStatusService.togglePlaying()"
          pTooltip="Prova il modulo"
          tooltipPosition="bottom"
        >
          <mat-icon svgIcon="heroicons_outline:play"></mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div
    class="mx-auto w-full max-w-[1300px] overflow-y-auto pl-20 pr-10 xl:pl-3"
  >
    <div
      cdkDropList
      [cdkDropListData]="dragDropService.sectionList()"
      (cdkDropListDropped)="drop($event)"
      id="sections"
      class="flex min-h-0 w-full flex-col gap-2 overflow-x-visible"
      #sectionContainer
    >
      @for (
        section of builderService.moduleStructure().root.children;
        track section;
        let i = $index
      ) {
        <lib-edit-section
          [id]="section"
          [sectionId]="section"
          [ref]="sectionContainer"
        ></lib-edit-section>
      }
    </div>
  </div>
</div>

<p-confirmDialog
  key="positionDialog"
  position="center"
  rejectButtonStyleClass="p-button-outlined"
  appendTo="body"
  #cd
>
  <ng-template pTemplate="footer">
    <div class="flex w-full flex-row gap-2">
      <button
        type="button"
        mat-flat-button
        style="border: 2px solid #6e6e6e"
        class="w-30"
        (click)="cd.onReject()"
      >
        Cancella
      </button>
      <button
        type="button"
        mat-flat-button
        color="accent"
        class="w-30"
        (click)="cd.onAccept()"
      >
        Conferma
      </button>
    </div>
  </ng-template>
</p-confirmDialog>
